// @ts-strict-ignore

import type { Route } from 'vue-router'

import type { GuardResolveFunction } from '../models'
import { deepEqual } from '@empathyco/x-utils'

import { mapActions, mapGetters } from 'vuex'

import { FilterIdEnum } from '../enums'

import { ANALYTICS_CONSTS } from '../store/analytics/analytics.consts'
import { CONTEXT_CONSTS } from '../store/context/context.consts'

export const AnalyticsMixin = {
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context,
    }),
    ...mapGetters(ANALYTICS_CONSTS.moduleName, {
      selectedId: ANALYTICS_CONSTS.getters.selectedId,
    }),
  },
  data() {
    return {
      contextWatchDisabled: false,
      currentFilters: undefined,
    }
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      reset: ANALYTICS_CONSTS.actions.reset,
      setSelectedId: ANALYTICS_CONSTS.actions.setSelectedId,
    }),
    loadData(): void {},
  },
  async beforeRouteLeave(to: Route, from: Route, next: GuardResolveFunction) {
    this.contextWatchDisabled = true
    await this.reset()
    if (this.selectedId) {
      await this.setSelectedId(undefined)
    }
    next()
  },
  mounted(): void {
    this.currentFilters = { ...this.context.filters }
    this.loadData()
  },
  watch: {
    context: {
      async handler(): Promise<void> {
        if (!this.contextWatchDisabled) {
          this.currentFilters[FilterIdEnum.COMPARE] = this.context.filters[FilterIdEnum.COMPARE]
          if (!deepEqual(this.context.filters, this.currentFilters)) {
            this.currentFilters = { ...this.context.filters }
            await this.reset()
          }
          this.loadData()
        }
      },
      deep: true,
    },
  },
}
